<template>
  <section class="mt-5 mb-5 overflow-hidden">
    <vue-headful
      :title="`เกี่ยวกับปืนธง - Thong Firearms ร้านปืนธง`"
      description="ร้านปืนธง เชี่ยวชาญทางด้านปืนมากขนาดไหนภาพนี้คงเป็นคำตอบได้
          เมื่อประมาณ 20 ปีที่แล้วหรือเมื่อปี พ.ศ.2540 ทางโรงงาน Smith&Wesson
          ได้เรียนเชิญเจ้าของร้านปืนธงไปที่งาน Shot Show ที่ประเทศสหรัฐอเมริกา
          เพื่อเปิดตัว Performance Center ได้รับอนุญาตให้ขายปืนถูกต้องตามกฎหมาย"
      image="https://thongarms.com/dist/logo.png"
      lang="th"
    />
    <div class="container">
      <div class="text-center">
        <h1 class="d-inline-block text-center mb-4 note">เกี่ยวกับเรา</h1>
      </div>

      <article class="max-width">
        <h5 class="mb-4 text-center color-red">
          ร้านปืนธง ได้รับอนุญาตให้ขายปืนถูกต้องตามกฎหมาย และ
          ขายปืนให้แก่บุคคลที่มีใบอนุญาตซื้อปืนเท่านั้น
        </h5>
        <div class="row mb-3 text-center">
          <div class="col-lg-12 col-sm-12">
            <img
              class="text-center mb-2"
              src="../assets/store03.jpg"
              alt="Thongarms Firearms store Thailand"
            />
          </div>
        </div>
        <h2>ประวัติความเป็นมา</h2>
        <p>
          ร้านปืนธงก่อตั้งเมื่อประมาณปี พ.ศ. 2490
          ซึ่งเป็นการเปิดกิจการร้านขายปืนในยุคสมัยแรกๆของประเทศไทย
          ในย่านวังบูรพา ประสบการณ์ที่สั่งสมมานานจากรุ่นสู่รุ่น ในนาม
          ห้างหุ้นส่วนจำกัด ปืนธง
          ทำให้ร้านปืนธงมีชื่อเสียงในด้านความรู้ของอาวุธปืนเป็นอย่างดี
          ทั้งปืนพื้นฐานไว้ป้องกันตัวไปจนถึงปืนไว้สำหรับแข่งขัน
        </p>
        <p>
          ถ้าถามว่าร้านปืนธง เชี่ยวชาญทางด้านปืนมากขนาดไหนภาพนี้คงเป็นคำตอบได้
          เมื่อประมาณปี พ.ศ. 2540 ทางโรงงาน Smith&Wesson
          ได้เรียนเชิญเจ้าของร้านปืนธงไปที่งาน Shot Show ที่ประเทศสหรัฐอเมริกา
          เพื่อเปิดตัว Performance Center
        </p>
        <div>
          <div class="row">
            <div class="col-lg-6 col-sm-12">
              <img
                class="text-center mb-2 float-lg-left mr-5"
                src="../assets/sw-pc-jerry-resize.jpg"
                alt="Jim Rae,Jerry Miculek"
              />
            </div>
            <div class="col-lg-6 col-sm-12">
              <p>
                หรือจะเป็นยี่ห้ออื่นๆ ทางร้านปืนธงก็เชี่ยวชาญ
                ไม่จำเป็นต้องเป็นเพียงแค่ยี่ห้อ Smith&Wesson
                ทางเรายินดีให้คำแนะนำแก่ลูกค้า
                โดยเจ้าของร้านผู้มีประสบการณ์มากกว่า 50 ปี
                ขายปืนถูกต้องตามกฎหมาย ขายให้ผู้ที่มีใบอนุญาตซื้อ (ใบ ป.3
                เท่านั้น)
              </p>
              <div class="my-2 mt-4">
                <ul>
                  <li>
                    บุคคลด้านซ้าย คุณ Jim Rae เป็นแกนนำผู้สร้างโมเดลต่างๆให้ปืน
                    Smith & Wesson โดยเฉพาะกลุ่ม Performance Center
                  </li>
                  <li>
                    บุคคลตรงกลางคงรู้จักกันดีอยู่แล้ว คุณ Jerry Miculek
                    นักยิงปืนเร็วและแม่นปืน ของ Smith & Wesson
                  </li>
                  <li>บุคคลด้านขวา คุณฉัตรชัย(ธง) เจ้าของร้านปืนธง</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </article>
      <article class="width-100 float-right mt-2">
        <div>
          <div class="row">
            <div class="col-lg-6 col-sm-12">
              <h2 class="mt-4 title">วิสัยทัศน์</h2>
              <p>
                เพื่อยกระดับความปลอดภัยในการป้องกันชีวิตและทรัพย์สิน
                ด้วยการใช้อาวุธปืนที่ถูกต้องและปลอดภัยแก่คนไทย
              </p>
              <h2 class="mt-4 title">พันธกิจ</h2>
              <p>
                ให้ความรู้ความเข้าใจขั้นตอนในการซื้อปืนและครอบครองปืนอย่างถูกกฎหมายในประเทศไทย
              </p>
            </div>
            <div class="col-lg-6 col-sm-12">
              <img
                class="text-center mb-2 float-lg-right"
                src="../assets/sw-pc-resize.jpg"
                width="100%"
                alt
              />
              <p class="width-100 text-lg-right text-sm-center">
                ผู้บริหารร้านปืนธง เข้าเยี่ยมชมโรงงานผลิตปืน
              </p>
            </div>
          </div>
        </div>
      </article>
    </div>
  </section>
</template>

<script>
export default {
  components: {
    name: "aboutUs"
  },
  data() {
    return {};
  }
};
</script>

<style>
.color-red {
  color: #eb1c23;
}
.title {
  border-bottom: solid 2px #ccc;
  padding: 5px;
}
.overflow-hidden {
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/component/aboutUs.vue